import { analytics } from '@qbe/qal';

export const logError = (error: unknown, extra?: object) => {
  if (extra) {
    console.error(extra, error);
  } else {
    console.error(error);
  }

  // Handle different types of errors
  if (typeof error === 'string') {
    // If the error is a string, log it using logDynatraceStackString
    analytics.logDynatraceStackString(error);
  } else if (error instanceof Error) {
    // If the error is an instance of Error, log it using logDynatraceStackTrace
    analytics.logDynatraceStackTrace(error);
  } else if (typeof error === 'object' && error !== null) {
    // If the error is an object (and not null), attempt to stringify and log it
    try {
      analytics.logDynatraceStackTrace(JSON.stringify(error));
    } catch (e) {
      // If stringification fails, log the failure to the console
      analytics.logDynatraceStackString('Failed to log error object');
      console.error('Failed to log error object:', e);
    }
  } else {
    // If the error type is unknown, log a warning to the console
    analytics.logDynatraceStackString('Received an unknown error type');
    console.warn('Received an unknown error type:', error);
  }
};
